import styled from 'styled-components'
import useSWR from 'swr'
import usePageContext from '../../Page/context'
import { APIGetMedallists } from '../../../endpoints'
import { FC } from 'react'
import MedalistsTitle from '../MedalistsTitle'


const ModuleMedallistsPhase1_5 = (props: any) => {
  const {
    state: { getEnvConfig }
  } = usePageContext()
  const { data } = useSWR(`${getEnvConfig.NEXT_CMS}${APIGetMedallists()}`)

  return (
    <StyledComponent className='px-0 mb-20 lg:mb-0'>
      <div className='snap-section-start theme-transparent hide-floating-logos relative top-[10px]' />
      {/* Make a 12 column grid with Tailwind */}
      <div className='wrapper'>
        <MedalistsTitle title={props.medallistBlockHeading} brief={props.medallistBlockHeadingBrief} />
        <div className='grid grid-cols-6 md:grid-cols-9 lg:grid-cols-12 gap-3 px-[30px]'>
          {data?.data.map((item: any) => (
            <Medalist key={item.id} name={item.attributes.name} $medalistImage={item.attributes.medallistPhaseOneDotFiveImage?.data?.attributes?.url} />
          ))}
        </div>
      </div>
    </StyledComponent>
  )
}

const Medalist: FC<IMedalistUI> = ({ name, ...props }) => {
  return (
    <StyledMedallist
      {...props}
    >
      {/* <div className='image' /> */}
      <img src={props.$medalistImage} alt={name} className='image' />
    </StyledMedallist>)
}

const StyledComponent = styled.div<any>`
  scroll-snap-align: start;
  > div.wrapper {
    justify-content: center;
    margin: 0 auto;
    align-items: center;

    @media (min-width: 1024px) {
      height: 100vh;
    }
  }
`

const StyledMedallist = styled.div<any>`
  position: relative;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 10px;

  img.image {
    margin: 0 auto;

    @media (min-width: 1024px) and (orientation: landscape) {
      height: 18vh;
    }
  }

  div.name {
    text-align: center;
  }
`

interface IMedalistUI {
  name: string
  $medalistImage: string
}

export default ModuleMedallistsPhase1_5